// extracted by mini-css-extract-plugin
module.exports = {"light_blue":"#66aef2","off_white":"#dadbdc","gray":"#50535a"};